"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var event_replayer_1 = require("./src/browser/event.replayer");
exports.EventReplayer = event_replayer_1.EventReplayer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVwbGF5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicmVwbGF5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsK0RBQTZEO0FBQXBELHlDQUFBLGFBQWEsQ0FBQSJ9